import { render, staticRenderFns } from "./Payed.vue?vue&type=template&id=36c8248d"
import script from "./Payed.vue?vue&type=script&lang=js"
export * from "./Payed.vue?vue&type=script&lang=js"
import style0 from "./Payed.vue?vue&type=style&index=0&id=36c8248d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports